export default __webpack_public_path__ + "static/media/plan@3x.96c36a4e.png";